import { Calendar, Box } from 'lucide-react';

interface EventsToggleProps {
  showEvents: boolean;
  onToggle: () => void;
  hasActiveEvent: boolean;
}

export function EventsToggle({ showEvents, onToggle, hasActiveEvent }: EventsToggleProps) {
  if (!hasActiveEvent) return null;

  return (
    <button
      onClick={onToggle}
      className="fixed top-16 right-4 z-50 flex items-center gap-2 bg-white/20 hover:bg-white/30 backdrop-blur-md text-white px-4 py-2 rounded-full shadow-lg transition-all border border-white/30"
      aria-label="Toggle between cards and events view"
    >
      {showEvents ? (
        <>
          <Box className="w-5 h-5" />
          <span className="hidden sm:inline font-semibold">3D Cards</span>
        </>
      ) : (
        <>
          <Calendar className="w-5 h-5" />
          <span className="hidden sm:inline font-semibold">Events</span>
        </>
      )}
    </button>
  );
}
